import { createUseStyles } from 'react-jss'

export default createUseStyles({
  actionSheet: {
    borderTopRightRadius: '30px',
    borderTopLeftRadius: '30px'
  },
  content: {
    margin: '0 auto',
    width: '85%'
  }
})
